module.exports = __webpack_public_path__ + "img/dog-purchase.d5fc05b6.png";